import React, { useState, useEffect, useCallback } from 'react';
import { Box, Flex, Spinner, useColorModeValue, useToast } from '@chakra-ui/react';
import axiosClient from "../../../api/axiosClient";

// Import sub-components
import ApprovalHeader from './components/ApprovalHeader';
import ApprovalTable from './components/ApprovalTable';

export default function TicketApproval() {
  const [transfers, setTransfers] = useState([]);
  const [loading, setLoading] = useState(true);
  const toast = useToast();

  const cardBg = useColorModeValue('white', 'navy.800');
  const textColor = useColorModeValue('secondaryGray.900', 'white');

  // Bungkus fungsi fetch pakai useCallback
  const fetchTransferRequests = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axiosClient.get('/ticket-transfer/list');
      
      // PERBAIKAN DI SINI: Tembus langsung ke dalam response.data.data.data (Array Utama)
      const dataResult = response.data?.data?.data || response.data?.data || response.data || [];
      setTransfers(dataResult);
    } catch (error) {
      toast({
        title: 'Gagal mengambil data',
        description: error.response?.data?.message || 'Terjadi kesalahan sistem backend.',
        status: 'error',
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  }, [toast]);

  // useEffect memanggil fungsi fetch saat pertama kali load
  useEffect(() => {
    fetchTransferRequests();
  }, [fetchTransferRequests]);

  // Handler Kirim Aksi Approve / Reject
  const handleApproval = async (transferId, action) => {
    try {
      await axiosClient.post(`/ticket-transfer/${action}/${transferId}`);
      
      toast({
        title: `Berhasil di-${action}`,
        description: `Pengajuan pengalihan tiket berhasil diproses.`,
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      
      fetchTransferRequests(); // Refresh data tabel
    } catch (error) {
      toast({
        title: 'Aksi Gagal',
        description: error.response?.data?.message || 'Gagal mengubah status pengalihan.',
        status: 'error',
        duration: 4000,
        isClosable: true,
      });
    }
  };

  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }} px="25px">
      <Box bg={cardBg} p="20px" borderRadius="20px" shadow="sm">
        
        {/* Sub-Component 1: Header */}
        <ApprovalHeader textColor={textColor} />

        {/* Loading Spinner atau Table Content */}
        {loading ? (
          <Flex justify="center" align="center" py="50px">
            <Spinner size="xl" color="brand.500" />
          </Flex>
        ) : (
          /* Sub-Component 2: Table List */
          <ApprovalTable 
            transfers={transfers} 
            textColor={textColor} 
            onApproval={handleApproval} 
          />
        )}

      </Box>
    </Box>
  );
}